<template>
  <v-row wrap column>
    <v-col class="mb-3" v-for="method in methodList"  :key="method.oauth2_access_method? method.oauth2_access_method.id :method.type" cols="12" justify-center>
      <login-with-button
        :href="method.url"
        :method-id="method.id"
        :idp-id="method.idpId"
        :state="method.state"
        :icon="method.icon"
        :src="method.src"
        :color="method.color"
        :open-mode="method.openMode"
        :label="label"
      >
        <template v-slot:default v-if="method.flavor === 'google'" >
          <div :class="method.id" id="my-signin2" style="margin: auto" :data-onsuccess="onSignIn"></div>
        </template>
      </login-with-button>
    </v-col>
  </v-row>
</template>

<script>
import LoginWithButton from './LoginButton'

export default {
  name: 'ButtonList',
  components: { LoginWithButton },
  props: {
    methods: {
      type: [Array],
      default: () => []
    },
    label: {
      type: [String],
      default: ''
    }
  },
  beforeMount () {
    this.$log.log(this.methods)
  },
  data () {
    return {
      methodList: this.methods.filter(item => item.type !== 'password')
    }
  },
  watch: {
    methods () {
      this.methodList = this.methods.filter(item => item.type !== 'password')
    }
  },
  methods: {
    onSignIn (googleUser) {
      let profile = googleUser.getBasicProfile()
      this.$log.log('ID: ' + profile.getId()) // Do not send to your backend! Use an ID token instead.
      this.$log.log('Name: ' + profile.getName())
      this.$log.log('Image URL: ' + profile.getImageUrl())
      this.$log.log('Email: ' + profile.getEmail()) // This is null if the 'email' scope is not present.
    }
  }
}
</script>

<style scoped>

</style>
